
import { APIData } from '../constants';
import useRest from './base/useRest';

// ACCOUNTS OR PRODUCTS

const preffix = "statements";

export const useStatementProfitAndLoss = (options?: APIData) => {
    return useRest(`${preffix}/profit-and-loss`, {operation: 'POST',  message: 'Generating Profit & Loss ...', ...options});
};

export const useStatementBalanceSheet = (options?: APIData) => {
    return useRest(`${preffix}/balance-sheet`, {operation: 'POST',  message: 'Generating Balance Sheet ...', ...options});
};